import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200" }
const _hoisted_2 = { class: "tarif-options-module tarif-options-module--add-on" }
const _hoisted_3 = { class: "o-grid o-grid--no-y-gutter add-on" }
const _hoisted_4 = {
  key: 0,
  class: "c-form-control"
}
const _hoisted_5 = ["name", "value", "data-cy", "aria-label"]
const _hoisted_6 = ["value", "disabled"]
const _hoisted_7 = {
  key: 1,
  class: "u-text-align-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.produktlinien, (produktLinie) => {
          return (_openBlock(), _createElementBlock("div", {
            key: produktLinie,
            class: _normalizeClass(_ctx.getCssForCol(produktLinie))
          }, [
            (_ctx.istGewaehlteProduktLinie(produktLinie))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("select", {
                    name: _ctx.name,
                    value: _ctx.modelValue,
                    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.inputChangeHandler($event)))),
                    class: "chooseOptionsSelect c-form-control-select u-text-align-center u-mar-0",
                    "data-cy": _ctx.name,
                    "aria-label": _ctx.name
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: option.value,
                        disabled: _ctx.sollOptionDeaktiviertWerden(option.value)
                      }, _toDisplayString(_ctx.pruefeVorbelegung(option)), 9, _hoisted_6))
                    }), 128))
                  ], 40, _hoisted_5)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.decorateSummeFuerAnzeige(_ctx.modelValue)), 1))
          ], 2))
        }), 128))
      ])
    ])
  ]))
}